import {
  Card,
  DELETE_WARNING,
  Grid,
  PAGE_DEFAULT,
  PAGE_SIZE_UNLIMITED,
  newToast,
  pn,
  useElementBreakpoints,
} from "@compass/core";
import { FilePanel } from "components";
import { Permission, PermissionAction, StudentFile as StudentFileModel, UploadFile } from "generated/openApi";
import "moment-timezone";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setAppToast } from "redux/reducers/appSlice";
import { isAuthorized } from "services";
import ApiService from "services/apiService";
import { initDataModel } from "utils";

export const StudentFiles = (props: { initialLoad: boolean; studentId: number }) => {
  const ROOT_PERMISSION: Permission = Permission.StudentFile;
  const { breakpointsRef, smallFieldBreakpoints } = useElementBreakpoints();
  const dispatch = useDispatch();
  const [files, setFiles] = useState<StudentFileModel[]>();

  const fetchList = () => {
    ApiService.studentFiles
      .getList({
        page: PAGE_DEFAULT,
        pageSize: PAGE_SIZE_UNLIMITED,
        sortObjects: [{ property: pn<StudentFileModel>("createdDate"), isDesc: true }],
        fileFilter: { studentId: props.studentId },
      })
      .then((response) => {
        setFiles(response);
      });
  };

  useEffect(() => {
    if (props.initialLoad) {
      fetchList();
    }
  }, [props.initialLoad]);

  return (
    <Card header="Files">
      <Grid ref={breakpointsRef} container spacing="sm">
        {files?.map((file, fileIndex) => (
          <Grid item key={fileIndex} xs={smallFieldBreakpoints}>
            <FilePanel
              fileName={file.uploadFile?.fileName}
              fileSize={file.uploadFile?.fileSize}
              fileRef={file.uploadFile?.fileRef}
              delete={
                isAuthorized(ROOT_PERMISSION, PermissionAction.Create)
                  ? () => {
                      if (window.confirm(DELETE_WARNING)) {
                        ApiService.studentFiles.delete(file.id).then(() => {
                          dispatch(setAppToast(newToast("success")));
                          fetchList();
                        });
                      }
                    }
                  : undefined
              }
            />
          </Grid>
        ))}

        {isAuthorized(ROOT_PERMISSION, PermissionAction.Create) && (
          <Grid item xs={smallFieldBreakpoints}>
            <FilePanel
              onFileChange={(fileName, fileSize, uploadingData) => {
                const newFile = initDataModel<StudentFileModel>({
                  studentId: props.studentId,
                  uploadFile: initDataModel<UploadFile>({
                    fileName: fileName,
                    fileSize: fileSize,
                    uploadingData: uploadingData,
                  }),
                });

                ApiService.studentFiles.saveCreate(newFile).then(() => {
                  dispatch(setAppToast(newToast("success")));
                  fetchList();
                });
              }}
            />
          </Grid>
        )}
      </Grid>
    </Card>
  );
};
